import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import { configService } from "@/services/config-service";
import MessageLayout from "@/modules/messages/MessageLayout.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MarketplaceAccountNotActivated',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MessageLayout, {
    image: "./email-sent.svg",
    title: "Finish your Nobl9 Registration",
    "need-help": false
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createTextVNode(" You already started your Nobl9 registration process. Check your mailbox and follow the instructions in the verification email to finish creating your Nobl9 account. If you didn’t receive the email, check the junk folder or ")),
      _createElementVNode("a", {
        href: _unref(configService).supportUrl
      }, "contact Nobl9 Support", 8, _hoisted_1),
      _cache[1] || (_cache[1] = _createTextVNode(". "))
    ]),
    _: 1,
    __: [0,1]
  }))
}
}

})